import { IFormUsecase } from '../../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../../Shared/Protocol/protocol-result'
import { HCPFlowService } from '../../../Services/HCP/flows/hcp-flow.service'
import {
  IHCPFlowKanbanPayload,
  IHCPFlowKanbanResponse,
} from '../../../Services/HCP/flows/hcp-flow.interface'

export class GetHCPFlowKanbanUseCase
  implements IFormUsecase<IHCPFlowKanbanPayload, IHCPFlowKanbanResponse>
{
  constructor(private readonly hcpFlowService: HCPFlowService) {}

  public async handle(
    data: IHCPFlowKanbanPayload
  ): Promise<Result<IHCPFlowKanbanResponse>> {
    try {
      return await this.hcpFlowService.getKanban(data)
    } catch (error: any) {
      return Result.fail(error)
    }
  }
}
